module.exports = {"meta":{"count":1,"average":1,"reviewed":1,"limit":5,"sids":["CWLPIL"],"averageAsInteger":1,"averageAsPercentage":20},"reviews":{"3923156":{"cid":"3923156","comment":"Too expensive.","ip_address":"172.22.2.77","sid":"CWLPIL","comment_date":"2022-09-19 00:00:00","status":"1","score":"1","name":"Mr Clarke","count":"0","total":"0","useful":"0","brand":"AP","travelled_with":"","usefulPercentage":"0","bookAgain":"","rating":"2","priority":" h1","product_name":"Premier Inn"}}}


//////////////////
// WEBPACK FOOTER
// ./config/exports/reviews/hotels/CWL.json
// module id = 158
// module chunks = 119